import { render, staticRenderFns } from "./riderWiseOFPReport.vue?vue&type=template&id=7941cd3a&"
import script from "./riderWiseOFPReport.vue?vue&type=script&lang=js&"
export * from "./riderWiseOFPReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports